import * as Actions from '../actions';

const initialState = {
    authList: [],
    currentAuth: {
        auth_id: 0,
        DeletedAt: null,
        Email: '',
        FirstName: '',
        LastName: '',
        Image: '',
        Password: '',
        PasswordConfirm: '',
        Phone: '',
        // Verification: '',
        // Verified: 0,
        Address: '',
        City: '',
        State: '',
        Zip: '',
        roles: [],
        deleted_roles: [],
        AuthActivityList: []
    },
    isAuthLoaded: false,
    companyInfo: {
        companyRoleActive: false,
        instructorRoleActive: false,
        company_ids: [],
        original_company_ids: []
    }
}

const crud = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_AUTH_LIST):
            {
                return {
                    ...state,
                    authList: action.payload
                }
            }
        case (Actions.GET_AUTH):
            {   
                let company_ids = action.payload ?
                    action.payload.companies.map(c => c.company_id)
                    :
                    []
                let companyCheck = action.payload ? 
                    action.payload.roles.filter(r => r.role_id === 5)
                    :
                    false
                let instructorCheck = action.payload ? 
                    action.payload.roles.filter(r => r.role_id === 3)
                    :
                    false
                
                return {
                    ...state,
                    currentAuth: { 
                        ...initialState.currentAuth, 
                        ...action.payload, 
                        // company_ids: company_ids,
                    },
                    companyInfo: {
                        companyRoleActive: companyCheck.length > 0 ? true : false,
                        instructorRoleActive: instructorCheck.length > 0 ? true : false,
                        // company_ids: state.companyInfo.company_ids === [] ? company_ids : state.companyInfo.company_ids,
                        company_ids: company_ids,
                        original_company_ids: company_ids
                    }
                };
            }
        case (Actions.UPDATE_AUTH_FORM):
            {   
                return {
                    ...state,
                    currentAuth: { ...state.currentAuth, ...action.payload }
                }
            }
        case (Actions.UPDATE_AUTH_COMPANIES):
            {  
                return {
                    ...state,
                    companyInfo: {
                        ...state.companyInfo,
                        company_ids: action.payload.company_ids
                    }
                }
            }
        case (Actions.UPDATE_AUTH_LOADED):
            {
                return {
                    ...state,
                    isAuthLoaded: action.payload
                }
            }
        case (Actions.UPDATE_AUTH_ROLE):
            {
                const newRole = action.payload.role
                const action_type = action.payload.action_type
                const roles = state.currentAuth.roles

                if (action_type === 'add') {
                    return {
                        ...state,
                        currentAuth: {
                            ...state.currentAuth,
                            roles: state.currentAuth.roles.concat({
                                active: 0,
                                RoleName: newRole.RoleName,
                                auth_id: state.currentAuth.auth_id,
                                link_id: 0,
                                role_id: newRole.role_id,
                                new: true
                            })
                        },
                        companyInfo: {
                            ...state.companyInfo,
                            companyRoleActive: newRole.role_id === 5 ? true: state.companyInfo.companyRoleActive,
                            instructorRoleActive: newRole.role_id === 3 ? true: state.companyInfo.instructorRoleActive
                        }
                    }
                }
                else {

                    const deleted_role = state.currentAuth.roles.filter(r => r.role_id === newRole.role_id && r.from_db === 1)[0]
                    return {
                        ...state,
                        currentAuth: {
                            ...state.currentAuth,
                            roles: state.currentAuth.roles.filter(r => r.role_id != newRole.role_id),
                            deleted_roles: state.currentAuth.deleted_roles.concat([deleted_role])
                        },
                        companyInfo: {
                            ...state.companyInfo,
                            companyRoleActive: newRole.role_id === 5 ? false: state.companyInfo.companyRoleActive,
                            instructorRoleActive: newRole.role_id === 3 ? false: state.companyInfo.instructorRoleActive
                        }
                    }
                }

            }
        case (Actions.PRELOAD_COMPANY):
            {
                if (state.currentAuth.auth_id === 0 && action.payload != 0) { // New User and company Pre-loaded
                    return {
                        ...state,
                        companyInfo: {
                            ...state.companyInfo,
                            company_ids: [action.payload]
                        }
                    }
                }
                else {
                    return { ...state }
                }
            }

        case (Actions.GET_AUTH_ACTIVITY_LIST):
            {
                return {
                    ...state,
                    currentAuth: {
                        ...state.currentAuth,
                        AuthActivityList: action.payload
                    }
                }
            }
        case (Actions.DROP_COMPANY):
            {
                return {
                    ...state,
                    companyInfo: {
                        ...state.companyInfo,
                        company_ids: state.companyInfo.company_ids.filter(id => id != action.payload)
                    }
                }
            }
        default:
            {
                return state
            }
    }

};

export default crud;


// WEBPACK FOOTER //
// src/auth/store/reducers/crud.reducer.js